import React, { ReactElement, useEffect, useState } from "react";
import {
    FormFieldReplacementInput,
    FormFieldType, FormType,
    WorkflowStepParameterInput, useGetActionFieldsQuery,
} from "../../../__generated__/api";
import FieldTypeValueDisplay from "../../form-field/FieldTypeValueDisplay";
import { LoadingIcon } from "../../loading/Loading";
import RequestTypes from "../../pickers/request-types/RequestTypes";
import { ActionProps } from "./base";
import BooleanSelect from "../../pickers/boolean/BooleanSelect";

const REQUEST_TYPE = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,requestType)";
const PARAMETERS_FIELD_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,parameters)";
const SHOULD_EXECUTE_FIELD_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,shouldExecute)";

export default function RunActionSettings(props: ActionProps): ReactElement {
    const requestType = props.values.find(row => row.value.fieldId === REQUEST_TYPE);
    const shouldExecuteParam = props.values.find(row => row.value.fieldId === SHOULD_EXECUTE_FIELD_ID)?.value?.boolean;

    const valuesType = props.values.find(row => row.value.fieldId === PARAMETERS_FIELD_ID);

    const [shouldExecute, setShouldExecute] = useState(shouldExecuteParam ?? true);

    const [parameters, setParameters] = useState<WorkflowStepParameterInput[]>(JSON.parse(valuesType?.value?.string ?? "[]"));

    const [selectedActionType, setSelectedActionType] = useState<{id: string, name: string} | undefined>(requestType ? {
        id: requestType?.value.string as string,
        name: requestType?.value.displayValue as string,
    } : undefined);

    const { data, loading } = useGetActionFieldsQuery({
        skip: !shouldExecute || selectedActionType == null,
        variables: {
            id: selectedActionType?.id,
        },
    });

    useEffect(() => {
        if (selectedActionType) {
            props.onChange({
                values: [
                    {
                        fieldId: REQUEST_TYPE,
                        type: FormFieldType.AsyncDropdown,
                        displayValue: selectedActionType?.name,
                        string: selectedActionType?.id,
                    },
                    {
                        fieldId: SHOULD_EXECUTE_FIELD_ID,
                        type: FormFieldType.AsyncDropdown,
                        displayValue: shouldExecute?.toString(),
                        boolean: shouldExecute,
                    },
                    {
                        fieldId: PARAMETERS_FIELD_ID,
                        type: FormFieldType.LongText,
                        displayValue: parameters.firstElement?.value?.string ?? "",
                        string: JSON.stringify(parameters),
                    },
                ],
            });
        }
    }, [selectedActionType?.id, parameters]);

    const fieldMap = data?.formFields.toIdMap("id") ?? {};
    return (
        <div className="">
            <div className="mb-4">
                <div className="">
                    Action
                </div>
                <div className="">
                    <RequestTypes
                        type={FormType.Default}
                        onSelected={(value, text) => {
                            setSelectedActionType({ id: value, name: text });
                            setParameters([]);
                        }}
                        value={selectedActionType?.id}
                    />
                </div>
                <small>
                    Which action do you want to run?
                </small>
            </div>

            <div className="mb-4">
                <div className="">
                    Should Execute Automation
                </div>
                <div className="">
                    <BooleanSelect
                        value={shouldExecute}
                        onChange={value => setShouldExecute(value ?? true)}
                    />
                </div>
                <small>
                    Should execute any automation associated with the request type.
                </small>
            </div>
            {shouldExecute && (
                <>
                    {loading && <LoadingIcon />}

                    {data?.form?.fields?.map(descriptor => {
                        const field = fieldMap[descriptor.fieldId];
                        const value = parameters.find(row => row.value.fieldId === field.id);
                        return (

                            <FieldTypeValueDisplay
                                key={field.id}
                                shouldShowFieldName
                                className="mb-3"
                                inputClassName="form-control"
                                field={field}
                                replaceableInput={props.input}
                                replacements={value?.replacement as FormFieldReplacementInput[]}
                                value={value?.value}
                                onChange={(changedValue, replacements) => {
                                    const copy = Array.from(parameters);
                                    const index = parameters.findIndex(row => row.value.fieldId === field.id);
                                    if (index >= 0) {
                                        copy[index] = {
                                            value: changedValue,
                                            replacement: replacements,
                                        };
                                    } else {
                                        copy.push({
                                            value: changedValue,
                                            replacement: replacements,
                                        });
                                    }
                                    setParameters(copy);
                                }}
                            />

                        );
                    })}

                </>
            )}

        </div>

    );
}
